<template>
  <div>
    <date-picker v-model="ls.day" valueType="format" :clearable="false"/>
    <br />
    <div>
        <button @click="previous()">&lt; Prev</button>
        <button @click="next()">Next &gt;</button>
      </div>
    
  </div>
</template>

<script>

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import localstorageMixin from '@/mixins/localstorageMixin.js'

export default {
  name:'GenericDaySelector',
  mixins: [localstorageMixin],
  data(){
    return {
      ls:{
        day: undefined,
      }
    }
  },
  components : {DatePicker},
  inject: ['page'],
  props:[
    'storeName', 'willLoadData',
  ],
  computed:{
    store(){return this.page.$refs[this.storeName]},
    timestamps(){ return this.store.timestamps},
  },
  mounted(){
    if(!this.ls.day || this.ls.day === "undefined")
          this.ls.day = new Date()
    
    if(this.willLoadData === true){
      this.$set(this.timestamps, 'from', moment(this.timestamps.from).startOf(this.timestamps.dateKey).format('YYYY-MM-DD HH:mm:ss'))
      this.$set(this.timestamps, 'to', moment(this.timestamps.from).endOf(this.timestamps.dateKey).format('YYYY-MM-DD HH:mm:ss'))
      this.store.loadData();
    } 
  },
  watch:{
    timestamps: {
      deep: true,
      handler(){
        this.ls.day = moment(this.timestamps.from).startOf('day').format('YYYY-MM-DD HH:mm:ss')
      }
    },
    ls: {
      // immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        if(!newVal.day || newVal.day === "undefined")
          newVal.day = new Date()
        this.$set(this.timestamps, 'from', moment(newVal.day).startOf('day').format('YYYY-MM-DD HH:mm:ss'))
        this.$set(this.timestamps, 'to', moment(newVal.day).endOf('day').format('YYYY-MM-DD HH:mm:ss'))
        console.log('Watcher LoadData', JSON.stringify(this.timestamps))
        console.log('Generic Day Selector', newVal.day, JSON.stringify(this.timestamps))
        this.store.loadData();
      },
    },
  },
  methods:{
    movePeriod(direction){
      // this.$set(this.timestamps, 'from', moment(this.timestamps.from)[direction](1, this.dateKey).format('YYYY-MM-DD HH:mm:ss'))
      // this.$set(this.timestamps, 'to', moment(this.timestamps.to).endOf(this.dateKey).format('YYYY-MM-DD HH:mm:ss'))
      // console.log('Debug 1', this.timestamps.from)
      this.$set(this.timestamps, 'from', moment(this.timestamps.from)[direction](1, 'day').format('YYYY-MM-DD HH:mm:ss'))
      // console.log('Debug 2', this.timestamps.from)
      this.$set(this.timestamps, 'to', moment(this.timestamps.from).endOf('day').format('YYYY-MM-DD HH:mm:ss'))
      this.ls.day = this.timestamps.from
      console.log('MovePeriod LoadData', JSON.stringify(this.timestamps))
      // this.store.loadData();
    },
    previous(){this.movePeriod('subtract')},
    next(){this.movePeriod('add')},
  }
}
</script>